import { gql } from 'apollo-angular';

const GET_CATEGORIES_BY_ORGANIZATION_ID_SELLERS = gql`
  query categoriesByOrganization($organizationId: Long!) {
    categoriesByOrganization(organizationId: $organizationId) {
      id
      name
      type
      effectiveDate
      categorizationScheme {
        id
        name
      }
      parent {
        id
        name
        type
      }
      statistic {
        productCount
      }
    }
  }
`;

export default GET_CATEGORIES_BY_ORGANIZATION_ID_SELLERS;
